module.exports = "<p>\n  attendeeform works!\n</p>\n"